import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={styles.page}>
      <div style={styles.content}>
        <h1>Privacy Policy</h1>
        <p style={styles.updated}>Last updated: February 2026</p>

        <h2>1. Who we are</h2>
        <p>
          This website is operated by <strong>ANY-Web Ltd.</strong>, a company registered in the United Kingdom.
          For privacy enquiries contact: <a href="https://www.any-web.uk/legal_privacy.aspx">any-web.uk/legal_privacy</a>
        </p>

        <h2>2. What data we process and why</h2>

        <h3>2.1 Server logs (legitimate interest)</h3>
        <p>
          When you visit this website, our servers automatically receive and log your IP address, browser
          type, referring page, and the time of your visit. This information is processed on the basis of
          our <strong>legitimate interest</strong> in operating and securing the service. Log data is retained
          for up to 30 days and is not shared with third parties for marketing purposes.
        </p>
        <p>
          Our infrastructure makes requests to the following domains, which receive your IP address as
          part of normal HTTP traffic:
        </p>
        <ul>
          <li><code>any-dns.co.uk</code> — serves page content and site configuration</li>
          <li><code>tablesdirect.co.uk</code> — serves site stylesheets</li>
        </ul>
        <p>Both domains are operated by ANY-Web Ltd.</p>

        <h3>2.2 Browser local storage (strictly necessary)</h3>
        <p>
          This website stores small amounts of data in your browser's local storage to make the site
          function correctly. See our <a href="/cookie-policy">Cookie &amp; Storage Policy</a> for full
          details. No personal data about you is stored in local storage — only site configuration and
          your language preference.
        </p>

        <h3>2.3 Fonts (self-hosted)</h3>
        <p>
          This website uses the Montserrat typeface, served directly from our own infrastructure.
          No request is made to Google Fonts or any third-party font provider.
        </p>

        <h2>3. Cookies</h2>
        <p>
          This website does <strong>not</strong> set any HTTP cookies. We do not use advertising cookies,
          tracking pixels, or analytics services. See our{' '}
          <a href="/cookie-policy">Cookie &amp; Storage Policy</a> for details on local storage use.
        </p>

        <h2>4. Your rights under UK GDPR / EU GDPR</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you</li>
          <li>Request correction of inaccurate data</li>
          <li>Request erasure of your data</li>
          <li>Object to processing based on legitimate interest</li>
          <li>Lodge a complaint with the ICO (UK) or your national supervisory authority (EU)</li>
        </ul>
        <p>
          To exercise your rights, contact us via{' '}
          <a href="https://www.any-web.uk/legal_privacy.aspx">any-web.uk/legal_privacy</a>.
        </p>

        <h2>5. Data retention</h2>
        <p>Server logs are retained for up to 30 days. Local storage data persists until cleared by the user.</p>

        <h2>6. Changes to this policy</h2>
        <p>
          We may update this policy. When we do, the "Last updated" date above will change.
          Continued use of the site after changes constitutes acceptance of the revised policy.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    padding: '40px 16px',
    background: '#fff',
  },
  content: {
    maxWidth: '760px',
    margin: '0 auto',
    fontFamily: 'Montserrat, sans-serif',
    color: '#1a1b1f',
    lineHeight: '1.7',
  },
  updated: {
    color: '#666',
    fontSize: '14px',
    marginBottom: '32px',
  },
};

export default PrivacyPolicy;
